import {
  Alignment,
  ConversationBubble,
  Direction,
  Displaying,
  Spacing,
  Typography,
} from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import type { IChatbotMessage } from "../../entities/chatbot-message.entity";
import { SenderTypeEnum } from "../../enums/sender-type.enum";
import { AiChatbotIconContainer } from "../ai-chatbot-icon-container/ai-chatbot-icon-container";
import { AiChatbotIcon } from "../ai-chatbot-icon/ai-chatbot-icon";
import AiResponseMarkdownMessageParser from "./ai-response-markdown-message-parser/ai-response-markdown-message-parser";

const AiMessageContainer = styled("div")({
  display: Displaying.flex,
  flexDirection: Direction.column,
  gap: Spacing["750"],
  alignSelf: Alignment.flexStart,
  maxWidth: "100%",
  wordBreak: "break-word",
});

const UserMessageContainer = styled(ConversationBubble)({
  alignSelf: Alignment.flexEnd,
});

interface ChatbotMessageItemProps {
  message: IChatbotMessage;
  animateAiMessage?: boolean;
}

export function ChatbotMessageItem({ message, animateAiMessage = false }: Readonly<ChatbotMessageItemProps>) {
  return message.senderType === SenderTypeEnum.USER ? (
    <UserMessageContainer text={message.text} fullWidth={false} maxWidth="100%" />
  ) : (
    <AiMessageContainer>
      <AiChatbotIconContainer>
        <AiChatbotIcon animated={false} />
      </AiChatbotIconContainer>
      <Typography variant="body1" color="textPrimary" component="div">
        <AiResponseMarkdownMessageParser markdownString={message.text} animate={animateAiMessage} />
      </Typography>
    </AiMessageContainer>
  );
}
